import React, { useEffect, useState } from "react";

import {
  Layout,
  Card,
  Button,
  Table,
  Tag,
  Avatar,
  Rate,
  Descriptions,
  Dropdown,
  Menu,
  Row,
  Col,
  Modal,
  Collapse,
  Select,
  Skeleton,
} from "antd";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  HomeOutlined,
  QrcodeOutlined,
  FileDoneOutlined,
  PrinterOutlined,
  ScheduleOutlined,
  CarOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import leftarrow from "../../../../assets/img/orders/leftarrow.png";
import customer from "../../../../assets/img/orders/orderDetail/customer.png";
import phone from "../../../../assets/img/orders/orderDetail/phone.png";
import message from "../../../../assets/img/orders/orderDetail/message.png";
import orderImg from "../../../../assets/img/orders/orderDetail/order.png";
import priceImg from "../../../../assets/img/orders/orderDetail/price.png";
import user from "../../../../assets/img/orders/orderDetail/user.png";
import whatsappStatus from "../../../../assets/img/orders/orderDetail/whatsappStatus.png";
import minusIcon from "../../../../assets/img/orders/minusIcon.png";
import plusIcon from "../../../../assets/img/orders/plusIcon.png";
import printImg from "../../../../assets/img/orders/orderDetail/print.png";
import QR from "../../../../assets/img/orders/orderDetail/QR.png";
import statuscustomer from "../../../../assets/img/orders/orderDetail/statuscustomer.png";
import storeStatus from "../../../../assets/img/orders/orderDetail/storeStatus.png";
import allStore from "../../../../assets/img/orders/orderDetail/allStore.png";
import prints from "../../../../assets/img/orders/orderDetail/prints.png";
import summaryIcon from "../../../../assets/img/orders/orderDetail/summary.png";

import duration from "../../../../assets/img/orders/orderDetail/duration.png";
import distance from "../../../../assets/img/orders/orderDetail/distance.png";
import vehicle from "../../../../assets/img/orders/orderDetail/vehicle.png";
import like from "../../../../assets/img/orders/orderDetail/like.png";
import summary from "../../../../assets/img/orders/orderDetail/like.png";

import pickAdd from "../../../../assets/img/orders/orderDetail/pickAdd.png";
import deliveryAdd from "../../../../assets/img/orders/orderDetail/deliveryAdd.png";
import editCollection from "../../../../assets/img/orders/editcollection.png";
import collectionDate from "../../../../assets/img/orders/collectionDate.png";
import deliverytime from "../../../../assets/img/orders/deliverytime.png";
import editdeleivery from "../../../../assets/img/orders/editdeleivery.png";
import iwashLogo from "../../../../assets/img/orders/orderDetail/iwash.png";

import jsPDF from "jspdf";

import moment from "moment";
import { API_GET_ORDER } from "api/order-management";
import { useParams } from "react-router-dom";
import { API_ORDER_STATUS } from "api/order-management";
import { API_LIST_LAUNDRY_MEN } from "api/laundry-management";
import { API_ASSIGN_ORDER_TO_DRIVER } from "api/laundry-management";
import { toast } from "react-toastify";
import { CONSTANTS } from "config/constant";
const { Header, Content } = Layout;
const { Panel } = Collapse;

const Printinvoice = ({ data }) => {
  // const data = location.state && location.state.data;

  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleItems, setIsModalVisibleItems] = useState(false);

  const [isModalVisibleDriver, setIsModalVisibleDriver] = useState(false);
  const [itemCounts, setItemCounts] = useState({});

  const [drivers, setDrivers] = useState();
  //   const [data, setData] = useState();
  const [status, setStatus] = useState(data?.order_status);
  const [activeKeys, setActiveKeys] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState(
    data?.order_user_info?.phone_no
  );

  let { id } = useParams();

  const [selectedRow, setSelectedRow] = useState(null);

  const showModal = (record) => {
    setSelectedRow(record);
    setIsModalVisibleItems(false);

    console.log("record in row", record);
  };

  const handleCancel = () => {
    setIsModalVisibleItems(false);
    setSelectedRow(null);
  };

  const handleCollapseChange = (key) => {
    setActiveKeys(key);
  };

  const handleDownload = () => {
    if (data?.qrCode) {
      // Initialize jsPDF instance
      const doc = new jsPDF();

      // Add image to PDF
      doc.addImage(data.qrCode, "PNG", 10, 10, 50, 50); // Adjust positioning and size as needed

      // Save PDF
      doc.save("qrCode.pdf");
    }
  };

  const fetchDataOrder = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_ORDER(id);
      console.log("provider", newData);
      //   setData(newData?.order);
      setStatus(newData?.order?.order_status);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const options = [
    "order_confirmed",
    "order_accepted",
    "driver_arrived_home_for_pickup",
    "order_pickedup_by_driver",
    "order_delivered_to_store_before_service",
    "order_pickedup_by_driver_to_laundry",
    "order_delivered_to_laundry_before_service",
    "order_service_completed",
    "order_pickedup_by_driver_after_service",
    "order_delivered_to_store_after_service",
    "order_pickedup_by_driver_to_deliver_to_customer",
    "order_delivered_successfully",
  ];
  const formattedOptions = options?.map((status) => ({
    value: status,
    label: status
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase()),
  }));
  const orderStatusToggle = async (value) => {
    try {
      const payload = {
        order_id: data?._id,
        order_status: value,
      };
      const userData = await API_ORDER_STATUS(payload);
      setStatus(value);
      toast.success(userData?.message);
    } catch (error) {
      toast.error("Server Error");

      console.error("error", error);
      // toast.error(error?.response?.data?.message);
    } finally {
      // setSubmitting(false);
    }
  };

  const fetchData = async () => {
    try {
      // setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_LAUNDRY_MEN(params);
      console.log("provider", newData);
      setDrivers(newData?.data?.laundryMen);
      // setLoading(false);
      setPagination({ ...pagination, total: newData.totalLaundryMen }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const handleCountMinus = (item) => {
    setItemCounts((prevItemCounts) => {
      const newCount = (prevItemCounts[item._id] || 1) - 1;
      if (newCount < 1) return prevItemCounts; // Prevent count from going below 1
      return {
        ...prevItemCounts,
        [item._id]: newCount,
      };
    });
  };
  const handleCountPlus = (item) => {
    setItemCounts((prevItemCounts) => ({
      ...prevItemCounts,
      [item._id]: (prevItemCounts[item._id] || 1) + 1,
    }));
  };
  const handleAssignDriver = async (driver) => {
    // Handle driver assignment logic here
    console.log("Assigned driver:", driver);

    try {
      const payload = {
        laundry_man_id: driver?._id,
        order_id: data?._id,
      };

      const response = await API_ASSIGN_ORDER_TO_DRIVER(payload);
      console.log("response", response);
      if (response) {
        setIsModalVisibleDriver(false);

        toast.success(response?.message);
      }
      fetchData(); // Refresh data after assigning order
    } catch (error) {
      console.error("Error assigning order to driver:", error);
      // message.error("Failed to assign order to driver");
    }
  };

  // let orderSummary = data?.items
  const calculateTotalPrice = (item) => {
    console.log("item cal", item);
    const total = item?.item_info?.item_service?.reduce(
      (total, service) => total + Number(service?.price),
      0
    );
    const itemCount = itemCounts[item._id] || 1;
    return total * itemCount;
  };
  const columns = [
    { title: "Name", dataIndex: "first_name", key: "first_name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Contact", dataIndex: "phone_no", key: "phone_no" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleAssignDriver(record)}>
          Assign
        </Button>
      ),
    },
  ];
  useEffect(() => {
    fetchDataOrder();
  }, [id]);
  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  console.log("data ==>order", data);

  const menu = (
    <Menu>
      <Menu.Item key="1">In Progress</Menu.Item>
      <Menu.Item key="2">Completed</Menu.Item>
      <Menu.Item key="3">Cancelled</Menu.Item>
    </Menu>
  );
  const uniqueServiceIds = [
    ...new Set(
      data?.items?.flatMap((item) =>
        item?.item_info?.item_service?.map((service) => service._id)
      )
    ),
  ];

  const laundryManInfo = data?.order_status_info;
  const lastLaundryManInfo = laundryManInfo
    ? laundryManInfo[laundryManInfo.length - 1]
    : null;
  console.log("uniqueServiceIds ", uniqueServiceIds);
  console.log("data ==>", data);
  return (
    <>
      <Layout>
        <Header className="flex  items-center justify-center bg-white p-4 ">
          <img src={iwashLogo} />
        </Header>
        <Content className="w-[706px] bg-white p-6 ">
          <div className="my-3 h-[1px] w-full bg-[#C5C5C5]"></div>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <div>
                <div className="flex items-center gap-2">
                  <p className="font-poppins text-[15px] font-normal leading-[37.66px] text-[#9496AE]">
                    Customer:
                  </p>
                  <p className="w-full text-[16px] font-medium leading-[37.66px] text-[#3860A4]">
                    {data?.order_user_info?.first_name +
                      " " +
                      data?.order_user_info?.last_name}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <img src={phone} className="h-[29px] w-[29px]" alt="" />
                  <p className="font-poppins text-[20px] font-medium leading-[37.66px] tracking-wide text-[#383838]">
                    {data?.order_user_info?.phone_no}
                  </p>
                </div>

                <p className="font-poppins text-[16px] font-medium leading-[28px] text-[#3860A4]">
                  {data?.order_user_info?.address?.[0]?.street
                    ? data?.order_user_info?.address?.[0]?.street
                    : data?.order_user_info?.address?.[0]?.location}
                </p>
              </div>
            </Col>
            <Col span={14}>
              <div className="flex flex-row items-start justify-end gap-12">
                <div className="flex flex-col gap-[24px]">
                  <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2">
                      <img
                        src={orderImg}
                        className="h-[34.72px] w-[34.72px]"
                        alt=""
                      />
                      <div>
                        <p className="font-poppins text-[14px] font-normal leading-[3.38px] text-[#9496AE]">
                          Order
                        </p>
                        <p className="text-[15px] font-medium text-[#3860A4]">
                          items ({data?.total_items}){" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <img
                      src={priceImg}
                      className="h-[34.72px] w-[34.72px]"
                      alt=""
                    />
                    <div>
                      <div className="flex justify-between">
                        <p className="font-poppins text-[14px] font-normal text-[#9496AE]">
                          Price
                        </p>
                      </div>
                      <p className="text-[15px] font-medium text-[#3860A4]">
                        {Number(data?.invoice_details?.total_amount).toFixed(2)}{" "}
                        SAR{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-2">
                  <img src={data?.qrCode} className="h-24 w-24" alt="" />
                </div>
              </div>
            </Col>
            <Col xs={24} lg={16}>
              <div className="flex flex-row items-center font-poppins text-[14px] font-normal leading-[3.38px] text-[#9496AE]">
                {" "}
                Order Id: &nbsp;{" "}
                <p className="text-[#3860A4]"> {data?.order_id}</p>
              </div>
              <div className="mt-[30px] flex flex-row items-center gap-3 rounded-t-[9px] bg-[#F5F5F7] px-7 py-3">
                <img src={summaryIcon} alt="" className="w-[]" />
                <p className="font-poppins text-[16px] font-medium leading-[28px] text-[#3860A4]">
                  Order Summary
                </p>
              </div>
            </Col>
            <Col xs={24} lg={16}>
              <div>
                {loading ? (
                  <>
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                  </>
                ) : (
                  <>
                    {/* <Card className="">
                    <Row gutter={[16, 16]}>
                      {uniqueServiceIds.map((serviceId) => {
                        const filteredItems = data?.items?.filter((item) =>
                          item?.item_info?.item_service?.some(
                            (service) => service?._id === serviceId
                          )
                        );
                        const serviceName =
                          filteredItems?.[0]?.item_info?.item_service?.find(
                            (service) => service._id === serviceId
                          )?.service_name;
                        return (
                          <Col xs={12} lg={12} key={serviceId}>
                            <Collapse
                              defaultActiveKey={["1"]}
                              style={{ border: "none" }}
                              expandIcon={() => null} className="custom-collapsessss2">
                              <Panel header={serviceName} key="1" style = {{borderBottom:'none'}}>
                                <Card
                                  type="inner"
                                  className="summary-table"
                                  style={{
                                    border: "none",
                                    padding: "0px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Table
                                    className="custom-tablesss"
                                    dataSource={filteredItems}
                                    columns={[
                                      {
                                        dataIndex: ["item_info", "item_name"],
                                        key: "item_info.item_name",
                                        render: (text, record) => (
                                          <span>
                                            {record?.item_info?.item_name}
                                          </span>
                                        ),
                                      },
                                      {
                                        dataIndex: "item_info.total_quantity",
                                        key: "item_info.total_quantity",
                                        render: (text, record) => (
                                          <span>
                                            {record?.item_info?.total_quantity +
                                              " " +
                                              "Items"}
                                          </span>
                                        ),
                                      },
                                      {
                                        dataIndex: "price",
                                        key: "price",
                                        render: (text, record) => (
                                          <span>
                                            {record?.item_info?.total_price +
                                              " " +
                                              "SAR"}
                                          </span>
                                        ),
                                      },
                                    ]}
                                    onRow={(record) => ({
                                      onClick: () => showModal(record),
                                    })}
                                    pagination={false}
                                    style={{
                                      border: "none",
                                      padding: "0",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Card>
                              </Panel>
                            </Collapse>
                          </Col>
                        );
                      })}
                    </Row>
                  </Card> */}
                    <div className="relative grid  grid-cols-2  ">
                      {/* {data?.items_grouped_by_services.length > 1 && (
                        <div className="absolute right-[53%] h-[100%] w-[1px] bg-[#C5C5C5]"></div>
                      )} */}
                      {/* <div className="absolute top-[53%] h-[1px] w-[300px] bg-[#C5C5C5]"></div> */}
                      {/* {data?.items_grouped_by_services.length > 1 && (
                        <div className="absolute right-6 top-[53%] h-[1px] w-[320px] bg-[#C5C5C5]"></div>
                      )} */}
                      {data?.items_grouped_by_services?.map(
                        (serviceId, index) => {
                          return (
                            <div
                              key={index}
                              className={`flex flex-col border-spacing-5 ${
                                index < 2 ? "justify-between" : "justify-start"
                              } ${index === 1 ? "ml-2" : ""}  ${
                                index === 0 ? "mr-3" : ""
                              }`} // Apply margin-left to the second group
                              // className={`flex flex-col justify-center  `}
                            >
                              {/* <div></div> */}
                              <h1
                                className={`mt-5 text-[16px] font-medium leading-[28px] text-[#3860A4]`}
                              >
                                {serviceId?.service_name}
                              </h1>
                              
                              <div className="mt-[12px] flex flex-col gap-[12px]">
                                {serviceId?.items?.map((element, idx) => (
                                  <div
                                    className="flex items-center justify-between font-poppins text-[14px] font-normal leading-[28px] text-[#9496AE]"
                                    key={idx}
                                  >
                                    <p className="w-1/3">
                                      {element?.item_name}
                                    </p>

                                    <p className="flex w-1/3 font-semibold">
                                      <p className="font-normal italic">
                                        Items: &nbsp;
                                      </p>{" "}
                                      {element?.quantity}
                                    </p>
                                    <p className="w-1/3 text-[16px] font-semibold leading-[10px] text-[#3860A4]">
                                      {element?.price * element?.quantity}
                                      &nbsp;SAR
                                    </p>
                                  </div>
                                ))}
                              </div>
                              {index < 2 && (
                                <hr className="my-4 border-t border-gray-300" />
                              )}
                              {/* {index === 0 && (
                                <div className="absolute right-0 top-0 h-full w-[1px] bg-gray-300"></div>
                              )} */}
                              
                            </div>
                          );
                        }
                      )}
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col xs={24} lg={16}>
              <div className="mt-[21px] h-[1px] w-full bg-[#C5C5C5]"></div>
              {/* <div className="current-status">
                <div>
                  <div className="mb-4 flex flex-col gap-5">
                    <hr className="mb-4" />

                    <div className="flex justify-between">
                      <span className="font-poppins text-[16px] font-normal text-[#9496AE]">
                        Order Type
                      </span>
                      <span className="font-poppins text-[17px] font-semibold text-[#3860A4]">
                        {data?.order_type}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[16px] font-normal text-[#9496AE]">
                        Tax
                      </span>
                      <span className="font-poppins text-[16px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.tax).toFixed(2) ?? 0} SAR
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[16px] font-normal text-[#9496AE]">
                        Total Items
                      </span>
                      <span className="font-poppins text-[19px] font-semibold text-[#3860A4]">
                        {data?.invoice_details?.total_items} Items
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[16px] font-normal text-[#9496AE]">
                        Delivery Fees
                      </span>
                      <span className="font-poppins text-[19px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.delivery_fee).toFixed(
                          2
                        ) ?? 0}{" "}
                        SAR
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[16px] font-normal text-[#9496AE]">
                        Total
                      </span>
                      <span className="font-poppins text-[19px] font-semibold text-[#FF0000]">
                        {Number(data?.invoice_details?.total_amount).toFixed(
                          2
                        ) ?? 0}{" "}
                        SAR
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="current-status">
              <Card>
                  <div className="mb-4">
                    <hr className="mb-4" />

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Service Category
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {data?.order_type}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Total Items
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {data?.invoice_details?.total_items} Items
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Service Charges
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(
                          data?.invoice_details?.sub_total_amount
                        ).toFixed(2)}{" "}
                        SAR
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Tax
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.tax).toFixed(2) ?? 0} SAR
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Delivery Fees
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.delivery_fee).toFixed(
                          2
                        ) ?? 0}{" "}
                        SAR
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Discount
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.discount).toFixed(2) ??
                          0}{" "}
                        SAR
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Total
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                        <Tag
                          color={
                            data?.invoice_details?.payment_status == "unpaid"
                              ? "red"
                              : "green"
                          }
                        >
                          {data?.invoice_details?.payment_status}
                        </Tag>{" "}
                        {Number(data?.invoice_details?.total_amount).toFixed(
                          2
                        ) ?? 0}{" "}
                        SAR
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                      Paid Amount
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[green]">
             
                        {Number(data?.invoice_details?.amount_paid).toFixed(
                          2
                        ) ?? 0}{" "}
                        SAR
                      </span>
                    </div>


                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        Pending Amount
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#800075]">
               
                        {Number(data?.invoice_details?.amount_due).toFixed(
                          2
                        ) ?? 0}{" "}
                        SAR
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default Printinvoice;
